import {Map, List, Seq} from 'immutable';
import moment from 'moment-timezone';

import {myRemoveEntities, myRemoveEntitiesBySport} from './utils';

import {LIVE_INIT, LIVE_UPDATE, TIMETABLE_INIT, TIMETABLE_UPDATE} from 'sagas/actions';

import * as LiveActions from 'actions/Live';
import * as LineActions from 'actions/Line';
import * as TimeTableActions from 'actions/Timetable';
import * as FavouritesActions from 'actions/Favourites';
import * as ExpandActions from 'actions/Expand';
import * as CollapseActions from 'actions/Collapse';
import * as ToggleMatchActions from 'actions/ToggleMatch';
import * as MatchResultActions from 'actions/MatchResults';
import * as StakeOfTheDayActions from 'actions/StakeOfTheDay';
import * as PopularActions from 'actions/Popular';

import * as FavouriteState from 'constants/FavouriteState';

export default function matchesReducer(matches, action) {
    switch (action.type) {
        case LiveActions.CLEAR_LIVE:
        case LineActions.CLEAR_LINE:
        case TimeTableActions.CLEAR_TIME_TABLE:
            return new Map();

        case LIVE_INIT.SUCCESS:
            if (action.data.events !== undefined) {
                matches = init(new Map(), action.data);
                matches = setMatchLineFullyLoaded(matches, action.data.events.add);
                matches = expandMatches(matches, action.data.events.add);
            } else {
                matches = new Map();
            }
            return matches;

        case TIMETABLE_INIT.SUCCESS:
            matches = init(new Map(), action.data);
            return matches;

        case LineActions.SUCCESS_REQUEST_LINE_HEADERS:
        case LineActions.SUCCESS_REQUEST_SPORT_LINE_HEADERS:
        case LineActions.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS:
        case MatchResultActions.SUCCESS_FETCH_MATCH_RESULTS:
        case StakeOfTheDayActions.SUCCESS_GET_STAKE_OF_THE_DAY:
        case PopularActions.SUCCESS_GET_POPULAR_MATCHES:
            return init(new Map(), action.data);

        case LineActions.SUCCESS_REQUEST_FULL_LINE:
            matches = init(matches, action.data);
            matches = setMatchLineFullyLoaded(matches, action.data.events.add);
            matches = expandMatches(matches, action.data.events.add);
            return matches;

        case LIVE_UPDATE.SUCCESS:
            matches = update(matches, action.data);
            if (action.data.events) {
                matches = expandMatches(matches, action.data.events.add);
            }
            return matches;

        case TIMETABLE_UPDATE.SUCCESS:
            return update(matches, action.data);

        case FavouritesActions.TOGGLE_FAVOURITE_SPORT:
            return toggleSportFavouriteMatches(matches, action.data);

        case FavouritesActions.TOGGLE_FAVOURITE_LEAGUE:
            return toggleLeagueFavouriteMatches(matches, action.data);

        case FavouritesActions.TOGGLE_FAVOURITE_MATCH:
            return toggleFavouriteMatch(matches, action.data);

        case ExpandActions.EXPAND_ALL_MATCHES:
            return expandAllMatches(matches);

        case CollapseActions.COLLAPSE_ALL_MATCHES:
            return collapseAllMatches(matches);

        case ToggleMatchActions.TOGGLE_MATCH:
            return toggleMatch(matches, action.data);
    }

    return matches;
}

function init(matches, data) {
    if (data.events !== undefined) {
        matches = addMatches(matches, data.events.add);
    }

    if (data.dates !== undefined) {
        matches = changeStartDates(matches, data.dates.add);
    }

    if (data.lines !== undefined) {
        matches = changeLineNumbers(matches, data.lines.add);
    }

    if (data.channels !== undefined) {
        matches = changeChannels(matches, data.channels.add);
    }

    if (data.blocked_events !== undefined) {
        matches = addBlockedMatches(matches, data.blocked_events.add);
    }

    if (data.remarks !== undefined) {
        matches = changeRemarks(matches, data.remarks.add);
    }

    if (data.periods !== undefined) {
        matches = changePeriods(matches, data.periods.add);
    }

    if (data.scores !== undefined) {
        matches = addMatchScores(matches, data.scores.add);
    }

    return matches;
}

function update(matches, data) {
    if (data.sports !== undefined && data.sports.remove !== undefined) {
        //matches = removeEntities(matches, 'sportId', data.sports.remove);
        matches = myRemoveEntitiesBySport(matches, 'sportId', data.sports.remove);
    }

    if (data.leagues !== undefined && data.leagues.remove !== undefined) {
        //matches = removeEntities(matches, 'leagueId', data.leagues.remove);
        matches = myRemoveEntities(matches, 'leagueId', data.leagues.remove);
    }

    if (data.events !== undefined) {
        //matches = removeEntities(matches, 'id', data.events.remove);
        matches = myRemoveEntities(matches, 'id', data.events.remove);
        matches = addMatches(matches, data.events.add);
        matches = setMatchLineFullyLoaded(matches, data.events.add);
    }

    if (data.blocked_events !== undefined) {
        matches = removeBlockedMatches(matches, data.blocked_events.remove);
        matches = addBlockedMatches(matches, data.blocked_events.add);
    }

    if (data.dates !== undefined) {
        matches = changeStartDates(matches, data.dates.add);
    }

    if (data.lines !== undefined) {
        matches = changeLineNumbers(matches, data.lines.add);
    }

    if (data.channels !== undefined) {
        matches = removeChannels(matches, data.channels.remove);
        matches = changeChannels(matches, data.channels.add);
        matches = changeChannels(matches, data.channels.change);
    }

    if (data.periods !== undefined) {
        matches = changePeriods(matches, data.periods.add);
        matches = changePeriods(matches, data.periods.change);
        matches = removePeriods(matches, data.periods.remove);
    }

    if (data.remarks !== undefined) {
        matches = removeRemarks(matches, data.remarks.remove);
        matches = changeRemarks(matches, data.remarks.add);
        matches = changeRemarks(matches, data.remarks.change);
    }

    if (data.scores !== undefined) {
        matches = removeMatchScores(matches, data.scores.remove);
        matches = addMatchScores(matches, data.scores.add);
    }

    return matches;
}

function addMatches(matches, addMatches) {
    if (addMatches === undefined) {
        return matches;
    }

    return matches.withMutations(m => {
        for (let i = 0; i < addMatches.length; i++) {
            let match = new Map(addMatches[i]);
            match = match.set('scores', new Map());
            match = match.set('groups', new List());
            match = match.set('isBlocked', false);
            match = match.set('isClosed', true);
            match = match.set('favouriteState', FavouriteState.NONE);
            match = match.set('isFullyLoaded', false);
            match = match.set('matchGroup', null);

            m.set(match.get('id'), match);
        }
    });
}

function setMatchLineFullyLoaded(matches, loadedMatches) {
    if (loadedMatches === undefined) {
        return matches;
    }

    for (let i = 0; i < loadedMatches.length; i++) {
        (match => {
            const matchId = match.id;
            matches = matches.setIn([matchId, 'isFullyLoaded'], true);
        })(loadedMatches[i]);
    }

    return matches;
}

function changeStartDates(matches, changeStartDates) {
    if (changeStartDates === undefined) {
        return matches;
    }

    for (let eventId in changeStartDates) {
        if (!changeStartDates.hasOwnProperty(eventId)) {
            continue;
        }

        ((matchId, startDate) => {
            startDate = moment.tz(startDate, 'Asia/Bishkek').clone().tz('UTC');

            matches = matches.setIn([parseInt(matchId), 'startDate'], startDate);
        })(eventId, changeStartDates[eventId]);
    }

    return matches;
}

function changeLineNumbers(matches, changeLineNumbers) {
    if (changeLineNumbers === undefined) {
        return matches;
    }

    for (let eventId in changeLineNumbers) {
        if (!changeLineNumbers.hasOwnProperty(eventId)) {
            continue;
        }

        ((matchId, lineNumber) => {
            matches = matches.setIn([parseInt(matchId), 'lineNumber'], lineNumber);
        })(eventId, changeLineNumbers[eventId]);
    }

    return matches;
}

function changeChannels(matches, changeChannels) {
    if (changeChannels === undefined) {
        return matches;
    }

    for (let eventId in changeChannels) {
        if (!changeChannels.hasOwnProperty(eventId)) {
            continue;
        }

        ((matchId, channel) => {
            matches = matches.setIn([parseInt(matchId), 'channel'], channel);
        })(eventId, changeChannels[eventId]);
    }

    return matches;
}

function removeChannels(matches, removeChannels) {
    //TODO implement in php for written logic
    if (removeChannels === undefined) {
        return matches;
    }

    for (let i = 0; i < removeChannels.length; i++) {
        (matchId => {
            matches = matches.deleteIn([matchId, 'channel']);
        })(removeChannels[i]);
    }

    return matches;
}

function changeRemarks(matches, changeRemarks) {
    if (changeRemarks === undefined) {
        return matches;
    }

    for (let eventId in changeRemarks) {
        if (!changeRemarks.hasOwnProperty(eventId)) {
            continue;
        }

        ((matchId, remark) => {
            matches = matches.setIn([parseInt(matchId), 'remark'], remark);
        })(eventId, changeRemarks[eventId]);
    }

    return matches;
}

function removeRemarks(matches, removeRemarks) {
    //TODO implement in php for written logic
    if (removeRemarks === undefined) {
        return matches;
    }

    for (let i = 0; i < removeRemarks.length; i++) {
        (matchId => {
            matches = matches.deleteIn([matchId, 'remark']);
        })(removeRemarks[i]);
    }

    return matches;
}

function changePeriods(matches, changePeriods) {
    if (changePeriods === undefined) {
        return matches;
    }

    for (let i = 0; i < changePeriods.length; i++) {
        (matchPeriod => {
            const matchId = matchPeriod.e;
            const periodId = matchPeriod.p;
            const minute = matchPeriod.m;

            const period = new Map({
                id: periodId,
                minute
            });

            matches = matches.setIn([matchId, 'period'], period);
        })(changePeriods[i]);
    }

    return matches;
}

function removePeriods(matches, removePeriods) {
    //TODO implement in php for written logic
    if (removePeriods === undefined) {
        return matches;
    }

    for (let i = 0; i < removePeriods.length; i++) {
        (matchId => {
            matches = matches.deleteIn([matchId, 'period']);
        })(removePeriods[i]);
    }

    return matches;
}

function addBlockedMatches(matches, addBlockedMatches) {
    if (addBlockedMatches === undefined) {
        return matches;
    }

    for (let i = 0; i < addBlockedMatches.length; i++) {
        const matchId = addBlockedMatches[i];

        (matchId => {
            matches = matches.setIn([matchId, 'isBlocked'], true);
        })(matchId);
    }

    return matches;
}

function removeBlockedMatches(matches, removeBlockedMatches) {
    if (removeBlockedMatches === undefined) {
        return matches;
    }

    for (let i = 0; i < removeBlockedMatches.length; i++) {
        const matchId = removeBlockedMatches[i];

        (matchId => {
            matches = matches.setIn([matchId, 'isBlocked'], false);
        })(matchId);
    }

    return matches;
}

function addMatchScores(matches, addScores) {
    if (addScores === undefined) {
        return matches;
    }

    for (let i = 0; i < addScores.length; i++) {
        (score => {
            const matchId = score.matchId;
            const scoreType = score.type;

            matches = matches.setIn([matchId, 'scores', scoreType], score.id);
        })(addScores[i]);
    }

    return matches;
}

function removeMatchScores(matches, removeScores) {
    if (removeScores === undefined) {
        return matches;
    }

    for (let i = 0; i < removeScores.length; i++) {
        (score => {
            const matchId = score.matchId;

            const scores = matches.getIn([matchId, 'scores']);
            const key = scores.keyOf(score.id);

            matches = matches.deleteIn([matchId, 'scores', key]);
        })(removeScores[i]);
    }

    return matches;
}

function toggleMatch(matches, toggledMatch) {
    const {matchId, isClosed} = toggledMatch;

    return matches.updateIn([matchId], m => {
        return m.set('isClosed', isClosed);
    });
}

function toggleSportFavouriteMatches(matches, sport) {
    const sportMatches = matches.valueSeq()
        .filter(m => m.get('sportId') === sport.get('id'))
        .map(m => m.get('id'))
        .toArray();

    const favouriteState = sport.get('favouriteState') === FavouriteState.FULL
        ? FavouriteState.NONE
        : FavouriteState.FULL;

    for (let i = 0; i < sportMatches.length; i++) {
        matches = matches.updateIn([sportMatches[i]], m => {
            return m.set('favouriteState', favouriteState);
        });
    }

    return matches;
}

function toggleLeagueFavouriteMatches(matches, league) {
    const leagueMatches = matches.valueSeq()
        .filter(m => m.get('leagueId') === league.get('id'))
        .map(m => m.get('id'))
        .toArray();

    const favouriteState = league.get('favouriteState') === FavouriteState.FULL
        ? FavouriteState.NONE
        : FavouriteState.FULL;

    for (let i = 0; i < leagueMatches.length; i++) {
        matches = matches.updateIn([leagueMatches[i]], m => {
            return m.set('favouriteState', favouriteState);
        });
    }

    return matches;
}

function toggleFavouriteMatch(matches, match) {
    return matches.updateIn([match.get('id')], m => {
        const favouriteState = m.get('favouriteState') === FavouriteState.FULL
            ? FavouriteState.NONE
            : FavouriteState.FULL;

        return m.set('favouriteState', favouriteState);
    });
}

function expandMatches(matches, loadedMatches) {
    if (loadedMatches === undefined) {
        return matches;
    }

    for (let i = 0; i < loadedMatches.length; i++) {
        matches = matches.updateIn([loadedMatches[i].id], m => {
            return m.set('isClosed', false);
        });
    }

    return matches;
}

function expandAllMatches(matches) {
    return Seq(matches).map(m => {
        return m.set('isClosed', false);
    }).toMap();
}

function collapseAllMatches(matches) {
    return Seq(matches).map(m => {
        return m.set('isClosed', true);
    }).toMap();
}



// WEBPACK FOOTER //
// ./js/shared/reducers/entities/matchesReducer.js